module.exports = __webpack_public_path__ + "img/flavor_cherry.4c2d6f65.png";